import React, { useState } from 'react';
import { Box, Grid, Typography, TextField, Button } from '@mui/material';
import 'dayjs/locale/ko'; 
import BaseCodeSelectbox from '../common/form/selectbox/BaseCodeSelectbox';
import DetailTemplate from '../common/template/DetailTemplate';
import PartnerModalConatiner from '../../containers/common/form/modal/PartnerModalConatiner';
import FormLabel from '../common/form/FormLabel';
import EmpModalContainer from '../../containers/common/form/modal/EmpModalContainer';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'


const ChanceForecastForm = ({ formik, onSelectedProducts }) => {
  const [expDay, setExpDay] = useState(null);
  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  const [openParnter, setOpenParnter] = useState(false);
  const handleOpen = () => {
    setOpenParnter(true);
  };
  const handleClose = () => {
    setOpenParnter(false);
  };

  const selectedPartner = (partner) => {
    formik.setFieldValue('partnerInc', partner.partnerNm);
  };

  const [openVendor, setOpenVendor] = useState(false);
  const handleOpenVendor = () => {
    setOpenVendor(true);
  };
  const handleCloseVendor = () => {
    setOpenVendor(false);
  };

  const selectedVendor = (partner) => {
    formik.setFieldValue('vendorCmp', partner.partnerUuid);
    formik.setFieldValue('vendorCmpNm', partner.partnerNm);
  };

  const [openEmp, setOpenEmp] = useState(false);
  const [title, setTitle] = useState('사원찾기');

  const openEmpModal = (type, title) => {
    setTitle(title);
    setOpenEmp(true);
  };
  const handleEmpClose = () => {
    setOpenEmp(false);
  };

  const selectedEmployee = (emp) => {
    formik.setFieldValue(`crtNm`, emp.usrNm, true);
    formik.setFieldValue(`crtUsr`, emp.usrUuid, false);
  };

  return (
    <Box>
      <DetailTemplate title="포캐스팅 등록">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            border: (theme) => `1px solid ${theme.palette.divider}`,
            bgcolor: 'background.paper',
            color: 'text.primary',
            p: 1,
          }}
        >
          <Grid
            container
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{
              py: 1,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Grid item xs={2}>
              <FormLabel>
                프로젝트 타입
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{ mx: 1, color: 'error.main' }}
                >
                  (필수)
                </Typography>
              </FormLabel>
            </Grid>
            <Grid item xs={4}>
              <BaseCodeSelectbox
                formik={formik}
                filterObject={{
                  blcCd: 'BASE',
                  mlcCd: 'FORCAST',
                  slcCd: 'PRJ_TYP',
                  useYn: 'Y',
                }}
                name="prjTyp"
                size="small"
                required={true}
              />
            </Grid>
            <Grid item xs={2}>
              <FormLabel sx={{ textAlign: 'right' }}>
                예산여부
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{ mx: 1, color: 'error.main' }}
                >
                  (필수)
                </Typography>
              </FormLabel>
            </Grid>
            <Grid item xs={4}>
              <BaseCodeSelectbox
                formik={formik}
                filterObject={{
                  blcCd: 'BASE',
                  mlcCd: 'FORCAST',
                  slcCd: 'BUGET_YN',
                  useYn: 'Y',
                }}
                name="bugetYn"
                size="small"
                required={true}
              />
            </Grid>
          </Grid>

          <Grid
            container
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{
              py: 1,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Grid item xs={2}>
              <FormLabel>
                프로젝트 중요도
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{ mx: 1, color: 'error.main' }}
                >
                  (필수)
                </Typography>
              </FormLabel>
            </Grid>
            <Grid item xs={4}>
              <BaseCodeSelectbox
                formik={formik}
                filterObject={{
                  blcCd: 'BASE',
                  mlcCd: 'FORCAST',
                  slcCd: 'PRJ_IMPT',
                  useYn: 'Y',
                }}
                name="prjImpt"
                size="small"
                required={true}
              />
            </Grid>
            <Grid item xs={2}>
              <FormLabel sx={{ textAlign: 'right' }}>제품여부</FormLabel>
            </Grid>
            <Grid item xs={4}>
              <BaseCodeSelectbox
                formik={formik}
                filterObject={{
                  blcCd: 'BASE',
                  mlcCd: 'FORCAST',
                  slcCd: 'PRD_YN',
                  useYn: 'Y',
                }}
                name="productYn"
                size="small"
                required={false}
              />
            </Grid>
          </Grid>

          <Grid
            container
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{
              py: 1,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Grid item xs={2}>
              <FormLabel>
                사업명
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{ mx: 1, color: 'error.main' }}
                >
                  (필수)
                </Typography>
              </FormLabel>
            </Grid>
            <Grid item xs={4}>
              <TextField
                size="small"
                required={true}
                variant="outlined"
                fullWidth
                id="cstNm"
                name="cstNm"
                value={formik.values.cstNm}
                onChange={formik.handleChange}
                error={formik.touched.cstNm && Boolean(formik.errors.cstNm)}
                helperText={formik.touched.cstNm && formik.errors.cstNm}
              />
            </Grid>
            <Grid item xs={2}>
              <FormLabel sx={{ textAlign: 'right' }}>
                매출(수금)예정일
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{ mx: 1, color: 'error.main' }}
                >
                  (필수)
                </Typography>
              </FormLabel>
            </Grid>
            <Grid item xs={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                  format="YYYY-MM-DD"
                  mask={'____-__-__'}
                  id="expDay"
                  name="expDay"
                  value={dayjs(expDay)}
                  onChange={(newValue) => {
                    setExpDay(dayjs(newValue));
                    onChangeDate(dayjs(newValue), 'expDay');
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      required={true}
                      fullWidth
                      error={
                        formik.touched.expDay && Boolean(formik.errors.expDay)
                      }
                      helperText={formik.touched.expDay && formik.errors.expDay}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{
              py: 1,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Grid item xs={2}>
              <FormLabel>
                매출처
                <Typography
                  variant="subtitle2"
                  component="span"
                  sx={{ mx: 1, color: 'error.main' }}
                >
                  (필수)
                </Typography>
              </FormLabel>
            </Grid>
            <Grid item xs={8}>
              <TextField
                size="small"
                required={true}
                variant="outlined"
                disabled
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="vendorCmpNm"
                name="vendorCmpNm"
                value={formik.values.vendorCmpNm}
                error={
                  formik.touched.vendorCmpNm &&
                  Boolean(formik.errors.vendorCmpNm)
                }
                helperText={
                  formik.touched.vendorCmpNm && formik.errors.vendorCmpNm
                }
              />
            </Grid>
            <Grid item xs={1}>
              <Button
                color="secondary"
                variant="outlined"
                size="small"
                onClick={handleOpenVendor}
              >
                매출처 선택
              </Button>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{
              py: 1,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Grid item xs={2}>
              <FormLabel>영업 담당자</FormLabel>
            </Grid>
            <Grid item xs={7}>
              <TextField
                size="small"
                required={true}
                variant="outlined"
                disabled
                fullWidth
                id="crtNm"
                name="crtNm"
                value={formik.values.crtNm}
                onChange={formik.handleChange}
                error={formik.touched.crtNm && Boolean(formik.errors.crtNm)}
                helperText={formik.touched.crtNm && formik.errors.crtNm}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => openEmpModal('', '영업담당자 선택')}
              >
                영업담당자 선택
              </Button>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
            sx={{ py: 1 }}
          >
            <Grid item xs={2}>
              <FormLabel>참고사항</FormLabel>
            </Grid>
            <Grid item xs={10}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth
                id="forcastTxt"
                name="forcastTxt"
                multiline
                rows={3}
                value={formik.values.forcastTxt}
                onChange={formik.handleChange}
                error={
                  formik.touched.forcastTxt && Boolean(formik.errors.forcastTxt)
                }
                helperText={
                  formik.touched.forcastTxt && formik.errors.forcastTxt
                }
              />
            </Grid>
          </Grid>
        </Box>
        {openParnter && (
          <PartnerModalConatiner
            link
            title="고객명 선택"
            open={openParnter}
            handleClose={handleClose}
            selectedPartner={selectedPartner}
          />
        )}
        {openVendor && (
          <PartnerModalConatiner
            link
            title="매출처 선택"
            open={openVendor}
            handleClose={handleCloseVendor}
            selectedPartner={selectedVendor}
          />
        )}
        {openEmp && (
          <EmpModalContainer
            title={title}
            multi={false}
            open={openEmp}
            roleTyp="SALES"
            handleClose={handleEmpClose}
            selectedEmployee={selectedEmployee}
          />
        )}
      </DetailTemplate>
    </Box>
  );
};

export default ChanceForecastForm;
